import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';

const ItemArchive = (props) => {

    const [state, setState] = useState({
        data: props.data,
        loader: true,
    })

    return (
        <div className="item-current item-archive">
            <div className="details-lattery">
                <div className="body-lottery">
                    <h4>{state.data.title}</h4>
                    <span>وضعیت شما : <b>{state.data.show_result}</b></span>
                    <div className="pic-rank">
                        {state.data.user_rank == 1 || state.data.user_rank == 2 || state.data.user_rank == 3 ?
                            <>
                                <img src="/icons/Group 11800.svg" />
                                <span>{state.data.user_rank}</span>
                            </>
                            :
                            <img src="/icons/Group 11810.svg" />
                        }
                    </div>
                    <Link to={`/lottery/${state.data.result_status ? 'expired' : 'details'}/${state.data.id}`} className="title-ltr">جزییات قرعه کشی</Link>
                </div>
            </div>
        </div>
    );
}

export default ItemArchive;